import styled from 'styled-components'

export const StyledTitle = styled.h2`
    text-align: center;
    color: #726A95;
`
